import React from 'react';
import { Image } from "@project-stories/elements/Image/Image";
import useColoredTextParser from '@src/hooks/useColoredTextParser';

export function SuccessStoryCard({ column, block }) {
  const renderSubtitle = useColoredTextParser({
    title: block?.settings.subtitle || '',
    accentTitleParts: block?.settings.enable_accent_parts ? (block?.settings.accent_title_parts || '') : '',
    accentColor: block?.settings.accent_color || '#AAAAAA',
    headerStyle: 'b_a3',
    classes: '',
  });

  const subtitleFormatted = block?.settings.subtitle
    ? block?.settings.enable_accent_parts
      ? renderSubtitle()
      : block.settings.subtitle
    : null;

  return (
    <div className="success-story relative aspect-[333/454] lg:aspect-[435/454] rounded overflow-hidden">
      <div className="success-story__image w-full h-full overflow-hidden">
        <Image
          imageUrl={column.image}
          alt={column.client_name}
          classes="w-full h-full object-cover"
        />
      </div>

      <div className={`success-story__info color-${block?.color_schema} absolute top-0 left-0 w-full h-full`}>
        <div className="absolute left-0 bottom-0 w-full lg:w-[75%] h-[55%] bg-gradient-to-b from-[rgba(30,30,30,0)] to-[#1E1E1E]"></div>
        <div className="absolute left-0 bottom-0 p-4 flex flex-col gap-4 w-full">
          <div className="flex flex-col gap-2">
            <div className="flex gap-4 items-start justify-between">
              <div className="b_regular_normal">
                {column.client_name}
              </div>
              {subtitleFormatted && (
                <div className="success-story__subtitle b_a3 py-1 px-2">
                  {subtitleFormatted}
                </div>
              )}
            </div>
            {column.title && (
              <div className="b_tiny_normal">
                {column.title}
              </div>
            )}
          </div>
          {column.handle && (
            <a
              href={`/pages/case-studies/${column.handle}`}
              className="b_a2 w-full flex gap-2 items-center justify-between hover:underline hover:decoration-[1px] hover:underline-offset-[2px]"
            >
              <span>{block?.settings.cta_text || 'View Case study'}</span>
              {block?.settings.cta_icon ? (
                <div className={`icon-${block?.settings.cta_icon} text-[24px] flex-shrink-0`}></div>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
                  <path d="M8.44444 11.5L13.5 6L8.44444 0.5M13.5 6L0.5 6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              )}
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default SuccessStoryCard;
